module.exports = __webpack_public_path__ + "img/btn-open.7bd3c051.png";